import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProviderRegistration from './pages/ProviderRegistration';
import LoginPage from './pages/LoginPage'
import PrivateRoute from './components/PrivateRoute'; // Import the wrapper
import Dashboard from './pages/ProviderDashboard';
import MainPage from './pages/MainPage';
import PaymentStatusPage from './pages/PaymentStatusPage';
import ForgotPassword from './pages/ForgotPassword';;
import ResetPassword from './pages/RessetPassword';
import CustomerLogin from './pages/CustomerLogin';
import CustomerRegistration from './pages/CustomerRegistration';
import CustomerDashboard from './pages/CustomerDashboard';
import CustomerPrivateRoute from './components/CustomerPrivateRoute';
import ScrollToTop from './pages/footers/ScrollToTop';
import { AboutUs } from './pages/footers/AboutUs';
import { ContactUs } from './pages/footers/ContactUs';
import { PrivacyPolicy } from './pages/footers/PrivacyPolicy';
import { TermsConditions } from './pages/footers/TermsConditions';
import { RefundPolicy } from './pages/footers/RefundPolicy';
import ServiceListingPage from './pages/ServiceListingPage';
import ProviderPage from './pages/ProviderPage';
import AdminLogin from './pages/AdminLogin';
import AdminWhatsAppConsole from './pages/AdminWhatsAppConsole';
import AdminPrivateRoute from './components/AdminPrivateRoute';





function App() {
	return (
		<Router>
			<ScrollToTop />
			<Routes>
				<Route path="/" element={<MainPage />} />
				<Route path="/register" element={<ProviderRegistration />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/admin-login" element={<AdminLogin />} />
				<Route
					path="/admin"
					element={
						<AdminPrivateRoute>
							<AdminWhatsAppConsole />
						</AdminPrivateRoute>
					}
				/>
				<Route path="/main" element={<MainPage />} />
				<Route path="/paymentStatus" element={<PaymentStatusPage />} />
				<Route path="/forgotPassword" element={<ForgotPassword />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				<Route path="/customer-login" element={<CustomerLogin />} />
				<Route path="/register-customer" element={<CustomerRegistration />} />
				<Route
					path="/customer-dashboard"
					element={
						<CustomerPrivateRoute>
							<CustomerDashboard />
						</CustomerPrivateRoute>
					}
				/>

				<Route path="/about-us" element={<AboutUs />} />
				<Route path="/contact-us" element={<ContactUs />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/terms-conditions" element={<TermsConditions />} />
				<Route path="/refund-policy" element={<RefundPolicy />} />
				<Route path="/provider/:providerId" element={<ProviderPage />} />
				<Route
					path="/service/:serviceType/:city"
					element={<MainPage />}
				/>

				<Route
					path="/service"
					element={<MainPage />}
				/>

				<Route
					path="/service/:serviceType"
					element={<MainPage />}
				/>

				{/* PROTECTED ROUTE */}
				<Route
					path="/dashboard"
					element={
						<PrivateRoute>
							<Dashboard />
						</PrivateRoute>
					}
				/>
			</Routes>
		</Router>
	);
}

export default App;
